import { BlogsFeedCategory } from 'mk2/apps/blogs/containers/BlogsFeed/BlogsFeedPage';
import { ComplaintEntity, ComplaintSchema } from 'mk2/containers/Complaint/Complaint.schemas';
import {
    complaintsDeleteAPI,
    ComplaintsDeleteAction,
    COMPLAINTS_DELETE,
} from 'mk2/containers/Complaints/Complaints.actions';
import { deleteComplaints } from 'mk2/containers/Complaints/Complaints.api';
import { findComplaintsNonDeleted } from 'mk2/containers/Complaints/Complaints.selectors';
import { pageHeaderFetchFlaggedCountsTrigger } from 'mk2/containers/PageHeader/PageHeader.action';
import { handleXHRPostErrorSaga, XHRAction, XHRPostError } from 'mk2/helpers/api';
import { tupdate } from 'mk2/helpers/types';
import { getLogger } from 'mk2/logger';
import { AppState } from 'mk2/reducers';
import { normalize } from 'normalizr';
import React from 'react';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

const logger = getLogger('Complaint.sagas');

export function* complaintsDelete({ entity, id, complaintId, deleteSubtree, xhr }: ComplaintsDeleteAction & XHRAction) {

    let complaints: ComplaintEntity[] = yield select(
        (state: AppState) => findComplaintsNonDeleted(state, entity, id),
    );

    // Clear local data
    if (!complaintId && !deleteSubtree) {
        complaints = complaints.map((complaint) => {
            return tupdate(complaint, {
                deletedAt: (new Date()).toISOString(),
            });
        });
    }
    else if (complaintId && !deleteSubtree) {
        complaints = complaints.reduce((acc, complaint) => {
            if (complaint.id === complaintId) {
                acc.push(tupdate(complaint, {
                    deletedAt: (new Date()).toISOString(),
                }));
            }
            return acc;
        }, []);
    }
    else if (deleteSubtree) {
        complaints = []; // cleared data will be received from the server
    }

    yield put(complaintsDeleteAPI.request(entity, id, complaintId, deleteSubtree));

    try {
        const response = yield call(deleteComplaints, xhr, entity, id, {
            ...(complaintId && { complaintId }),
            ...(deleteSubtree && { deleteSubtree }),
        });

        const normalizedResponse = ('complaints' in response.body)
            ? normalize(response.body.complaints, [ComplaintSchema])
            : normalize(complaints, [ComplaintSchema]);

        yield put(pageHeaderFetchFlaggedCountsTrigger());

        yield put(complaintsDeleteAPI.success(entity, id, normalizedResponse));
    } catch (error) {
        yield handleXHRPostErrorSaga(error as XHRPostError, logger);
        yield put(complaintsDeleteAPI.failure(entity, id, error));
    }
}

export default function* root() {
    yield all([
        takeEvery(COMPLAINTS_DELETE, complaintsDelete),
    ]);
}
